import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import takeawayHero from "../assets/takeaway-hero.jpg";
import { Link } from "react-router-dom";

const Takeaway = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
        <img
          src={takeawayHero}
          alt="Burgersson Takeaway"
          className="absolute inset-0 w-full h-full object-cover"
          width={1920}
          height={1080}
        />
        <div className="hero-overlay absolute inset-0" />
        <div className="relative z-10 text-center px-8 fade-in-up flex flex-col items-center gap-20 max-w-4xl mx-auto">
          <div>
            <h1
              className="font-heading text-3xl md:text-5xl lg:text-6xl tracking-wide text-foreground uppercase mb-8"
              style={{ lineHeight: "1.3" }}
            >
              Burgersson Take Away Burgare
            </h1>
            <p className="font-body text-sm md:text-base text-muted-foreground max-w-2xl mx-auto mb-8 uppercase tracking-wide leading-relaxed">
              Ring oss eller beställ online och hämta själv
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
              <Link
                to="tel:+46317303062"
                className="px-6 md:px-8 py-2.5 md:py-3 rounded-full border border-foreground/40 text-xs md:text-sm font-body font-medium uppercase tracking-widest text-foreground hover:bg-foreground hover:text-background transition-all duration-300"
              >
                Tel:031-7303062
              </Link>
              <Link
                to="https://hey.hn/sksln"
                target="_blanck"
                className="px-6 md:px-8 py-2.5 md:py-3 rounded-full border border-foreground/40 text-xs md:text-sm font-body font-medium uppercase tracking-widest text-foreground hover:bg-foreground hover:text-background transition-all duration-300"
              >
                Avhämtning / Pick-up
              </Link>
            </div>
          </div>
          <div>
            <p className="font-heading text-xl md:text-2xl tracking-wide text-foreground uppercase mb-8 leading-[1.15]">
              Beställ online och få din mat levererad
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
              <Link
                to="https://anconorder.com/en/outlet/barleys-food-factory/table-order?embedded=true"
                target="_blanck"
                className="px-6 md:px-8 py-2.5 md:py-3 rounded-full border border-foreground/40 text-xs md:text-sm font-body font-medium uppercase tracking-widest text-foreground hover:bg-foreground hover:text-background transition-all duration-300"
              >
                Takeaway
              </Link>
            
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Takeaway;
